import { create } from "zustand";
import type { TimelinePanelStoreState } from "./types";

export const useTimelinePanelStore = create<TimelinePanelStoreState>((set) => ({
  isOpen: false,
  drawerWidth: 0,
  targetDrawer: null,
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
  setDrawerWidth: (drawerWidth: number) => set({ drawerWidth }),
  setTargetDrawer: (targetDrawer: string | null) => set({ targetDrawer }),
}));
